import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  
  socialMedia = [
    {
      iconClass: "fb",
      icon: "icofont icofont-social-facebook",
      url: "https://www.facebook.com/people/Digital-alchemy/61565618420833", // Added proper Facebook link
      name: "Facebook"
    },
    {
      iconClass: "be",
      icon: "icofont icofont-social-behance",
      url: "https://www.behance.net/digitalalchemy2",
      name: "Behance"
    },
    {
      iconClass: "in",
      icon: "icofont icofont-social-linkedin",
      url: "https://www.linkedin.com/company/digital-alchemy-ma/",
      name: "LinkedIn"
    },
    {
      iconClass: "yt",
      icon: "icofont icofont-social-youtube",
      url: "https://www.youtube.com/@Digital_Alchemy_ma",
      name: "YouTube"
    },
    {
      iconClass: "ins",
      icon: "icofont icofont-social-instagram",
      url: "https://www.instagram.com/digital_alchemy_ma/",
      name: "Instagram"
    }
  ];
}